import { FC, ReactNode } from "react"

interface SectionOutletProps {
  title: string
  children: ReactNode
}

export const SectionOutlet: FC<SectionOutletProps> = ({ title, children }) => {
  return <div className="space-y-6">
    <div className="bg-white rounded-xl p-6 shadow-sm border">
      <div className="flex items-center gap-2 mb-6">
        <h3 className="text-lg font-semibold">
          {title}
        </h3>
      </div>
      <div>
        {children}
      </div>
    </div>
  </div>

}
